import { Box, Button, Grid, Stack, Typography } from "@mui/material";

import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ColorScheme } from "../../../Themes/ColorScheme";
import { ApiContext } from "../../ApiContext";
import { Spinner } from "../../Common/Spinner";

export const ListMessages = () => {
	const debug = false;

	const [notifications, setNotifications] = useState([]);
	const [selectedPage, setSelectedPage] = useState(1);
	const [loading, setLoading] = useState(true);

	const { ApiCall } = useContext(ApiContext);
	const { t } = useTranslation();

	function parseMessage(message) {
		// Split the message into words
		const words = message.split(" ");

		// Map through the words, turning any word that matches the URL pattern into a link
		return words
			.map((word, index) => {
				const urlPattern =
					/(https?:\/\/[^\s]+)|(www\.[^\s]+)|((?:[a-z]+\.)?[a-z0-9]+\.[a-z]+(?:\.[a-z]+)?)|(https?:\/\/[^\s]+:\d+)|(https?:\/\/[^\s]+\/[^\s]*)|([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
				const match = urlPattern.exec(word);
				if (match) {
					return (
						<a
							key={index}
							href={
								match[0].startsWith("http")
									? match[0]
									: `http://${match[0]}`
							}
							target="_blank"
							rel="noopener noreferrer"
						>
							{match[0]}
						</a>
					);
				} else {
					return word;
				}
			})
			.reduce(
				(prev, current, index) =>
					// Add a space after each word, except the last one
					index < words.length - 1
						? [...prev, current, " "]
						: [...prev, current],
				[]
			);
	}

	function loadMore() {

		setLoading(true);

		ApiCall("GET", "user/notifications?page=" + selectedPage, null)
			.then((res) => {
				setNotifications(res.slice(0, 10)); // Only first 10
				setLoading(false);
			}).catch((err) => {
				if (debug) console.log(err);
				setLoading(false);
			});
	}

	useEffect(() => {
		loadMore();
	}, []);

	function getCreatedDateDaysAgo(date) {
		const oneDay = 24 * 60 * 60;

		const now = new Date().getTime();
		const notif_date = new Date(date).getTime();

		const diffSeconds = Math.floor((now - notif_date) / 1000);

		const diffMinutes = Math.round(diffSeconds / 60);
		const diffHours = Math.round(diffSeconds / 3600);

		const diffDays = Math.round(diffSeconds / oneDay);

		if (diffMinutes < 60) return diffMinutes + " " + t("time.minutes_ago");

		if (diffHours < 24) return diffHours + " " + t("time.hours_ago");

		if (diffDays === 0) return t("time.today");
		else if (diffDays === 1) return t("time.yesterday");
		else return diffDays + " " + t("time.days_ago");
	}

	return (
		<Box
			sx={{
				width: "100%",
				height: "100%",
				flex: 1,
			}}
		>
			<Box
				sx={{
					width: "inherit",
					borderRadius: "4px",
					display: "flex",
					flexDirection: "column",
					flex: 1,
				}}
			>
				<div style={{ height: "20px" }} />

				{!loading && notifications.length === 0 ? (
					<Typography
						sx={{
							marginBottom: "20px",
							fontSize: "18px",
							fontWeight: "700",
							color: ColorScheme.textSecondary
						}}
					>
						{t("notifications.no_notifications")}
					</Typography>
				) : (
					<Typography
						sx={{
							marginBottom: "20px",
							fontSize: "18px",
							fontWeight: "700",
						}}
					>
						{t("notifications.notification_label")}
					</Typography>
				)}

				{notifications.map((notification, index) => (
					<React.Fragment key={index}>
						<Grid
							item
							xs={12}
							sx={{
								border: "1px solid " + ColorScheme.lightGrey,
								color: ColorScheme.black,
								my: "5px",
								padding: "10px",
								borderRadius: "4px",
								width: "250px", // USSR solution
							}}
						>
							{notification.location !== null && (
								<Typography
									sx={{
										fontWeight: "700",
										fontSize: "14px"
									}}
								>
									{location.name}
								</Typography>
							)}
							<Stack
								direction="row"
								style={{
									alignItems: "center",
									justifyContent: "space-between",
									borderBottom:
										"1px solid" + ColorScheme.lightGrey
								}}
							>
								<Stack direction="row">
									<Typography
										sx={{
											fontWeight: "700",
											fontSize: "14px"
										}}
									>
										{notification.title}
									</Typography>
								</Stack>
								<Typography
									sx={{
										fontSize: "10px",
									}}
								>
									{getCreatedDateDaysAgo(
										notification.created_at
									)}
								</Typography>
							</Stack>
							<Typography
								sx={{
									padding: "5px",
									fontSize: "12px",
								}}
							>
								{parseMessage(notification.message)}
							</Typography>
						</Grid>
						<Box
							sx={{
								width: "100%",
								height: "1px",
								alignSelf: "center"
							}}
						/>
					</React.Fragment>
				))}

				{loading && (
					<Spinner color={ColorScheme.primary}/>
				)}
				
				<div style={{flex: 1, width: "100%"}}></div>

				<Stack
					style={{
						width: "100%",
						justifyContent: "center",
						alignItems: "center"
					}}
				>
				</Stack>
			</Box>
		</Box>
	);
};
